<div class="introduction-section">
    <div class="details-content">
        <div class="title">{{ 'events.reforestaction.introduction.title' | translate }}</div>
        <div class="image-content" *ngIf="responsiveScreenService.isOrSmaller('m')">
            <img src="assets/images/reforestaction/intro.webp" />
        </div>
        <div class="text">
            {{ 'events.reforestaction.introduction.text' | translate }}
        </div>
        <div class="app-links">
            <a 
                href="https://play.google.com/store/apps/details?id=com.kinomap.training&hl=fr&gl=US"
                target="_blank"
                class="image-container"
            >
                <img src="assets/images/google_store.webp" />
            </a>
            <a 
                href="https://apps.apple.com/fr/app/kinomap/id611177969"
                target="_blank"
                class="image-container"
            >
                <img src="assets/images/app_store.webp" />
            </a>
        </div>
    </div>
    <div class="image-content" *ngIf="responsiveScreenService.isOrBigger('HD-s')">
        <img src="assets/images/reforestaction/intro.webp" />
    </div>
</div>